<template>
  <div>
    <div class="box">
      <BInputText
        label-text="api-url"
        :maxLength="255"
        :required="true"
        v-model="addParam.apiUrl"
        placeholder="请输入api-url"
      />
      <BInputText
        label-text="api名称"
        :maxLength="45"
        :required="true"
        v-model="addParam.apiName"
        placeholder="请输入api名称"
      />
    </div>
    <div class="box-btn">
      <BBtnPrimary :clicked="doSave" btn-txt="保存" />
      <BBtnPrimary :clicked="doBack" btn-txt="返回" />
    </div>
  </div>
</template>
<script>
import { insertApiInfo, updateApiInfo } from "@/api/pageManagement";
import BInputText from "../../components2/BInputText";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
export default {
  name: "VersionManagementAdd",
  components: {
    BInputText,
    BBtnPrimary,
  },
  data() {
    return {
      addParam: {
        apiUrl: '',
        apiName: '',
      },
      pageId: 0,
      editFlg: "",
      id: 0,
      navi: [
          { name: "page-management" },
          { name: "page-management-add" },
          { name: "page-management-detail-add" },
        ],
    };
  },
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  created () {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.pageId = vm.$route.params.pageId;
      vm.editFlg = vm.$route.params.editFlg;
      vm.id = vm.$route.params.id;

      if (vm.$route.params.apiUrl != null && vm.$route.params.apiName != null) {
        vm.addParam.apiUrl = vm.$route.params.apiUrl;
        vm.addParam.apiName = vm.$route.params.apiName;
      }

      if (vm.pageId) {
        // 把不为空的参数存入缓存
        const params = {
          pageId: vm.pageId,
          apiUrl: vm.addParam.apiUrl,
          apiName: vm.addParam.apiName,
          editFlg: vm.editFlg,
        };
        vm.$store.commit("SET_PAGE_DETAIL_ADD_PARAMS", params);
      }

      // 参数赋值
      if (vm.$store.state.pageManagementDetailAdd_pageId) {
        vm.pageId = vm.$store.state.pageManagementDetailAdd_pageId;
      }
      if (vm.$store.state.pageManagementDetailAdd_apiUrl) {
        vm.addParam.apiUrl = vm.$store.state.pageManagementDetailAdd_apiUrl;
      }
      if (vm.$store.state.pageManagementDetailAdd_apiName) {
        vm.addParam.apiName = vm.$store.state.pageManagementDetailAdd_apiName;
      }
      if (vm.$store.state.pageManagementDetailAdd_editFlg) {
        vm.editFlg = vm.$store.state.pageManagementDetailAdd_editFlg;
      }
    });
  },
  methods: {
    doSave() {
      if (!this.addParam.apiUrl) {
        Vue.prototype.$valertbar.show("请输入api-url！");
        return false;
      }
      if (!this.addParam.apiName) {
        Vue.prototype.$valertbar.show("请输入api名称！");
        return false;
      }
      if (this.editFlg == "1") {
        this.update();
      } else {
        this.add();
      }
    },
    async add() {
      var params = {
        pageId: this.pageId,
        apiUrl: this.addParam.apiUrl,
        apiName: this.addParam.apiName,
      };
      console.log(this.pageId);
      const data = await insertApiInfo(params);
      if (data === 1) {
        this.doBack();
        Vue.prototype.$vsnackbar.show("保存成功！");
      } else if (data === 0){
        Vue.prototype.$valertbar.show("保存失败！");
      } else if (data === -1) {
        Vue.prototype.$valertbar.show("api-url重复，请重新输入！");
      } else if (data === -2) {
        Vue.prototype.$valertbar.show("api名称重复，请重新输入！");
      }
    },
    async update() {
      var params = {
        pageId: this.pageId,
        apiUrl: this.addParam.apiUrl,
        apiName: this.addParam.apiName,
        id: this.id,
      };
      const data = await updateApiInfo(params);
      if (data === 1) {
        this.doBack();
        Vue.prototype.$vsnackbar.show("保存成功！");
      } else if (data === 0) {
        Vue.prototype.$valertbar.show("保存失败！");
      } else if (data === -1) {
        Vue.prototype.$valertbar.show("api-url重复，请重新输入！");
      } else if (data === -2) {
        Vue.prototype.$valertbar.show("api名称重复，请重新输入！");
      }
    },
    doBack() {
      this.$router.push({
        name: "page-management-detail",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
}

.box-btn {
  display: flex;
  flex-direction: row;
  margin-left: 200px;
  margin-top: 70px;
}
</style>
